import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'RadioOff',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M2.85 18.15c-.23-.5-.35-1.06-.35-1.65 0-2.21 1.79-4 4-4 .59 0 1.14.13 1.65.35m1.63 1.37c.45.65.72 1.43.72 2.28 0 2.21-1.79 4-4 4-.85 0-1.64-.26-2.28-.72M20.5 18.5h-7m7-2h-7m7-2h-7M1.68 22.32c.25.11.53.18.82.18h19c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2h-4m-3 0h-12c-1.1 0-2 .9-2 2v12m2-14l10-5" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "23.5", y1: ".5", x2: ".5", y2: "23.5" }
      }), h("path", {
        attrs: { d: "M6.5 14A2.5 2.5 0 0 0 4 16.5c0 .36.08.69.21 1l3.29-3.29c-.31-.13-.64-.21-1-.21zm-1.19 4.69c.36.19.76.31 1.19.31A2.5 2.5 0 0 0 9 16.5c0-.43-.12-.83-.31-1.19l-3.38 3.38zM21 8h-4v2h4c.55 0 1-.45 1-1s-.45-1-1-1z" }
      }), h("polygon", {
        attrs: { points: "16,10 16,8 14,10" }
      }), h("path", {
        attrs: { d: "M2 9c0 .55.45 1 1 1h8.71l2-2H3c-.55 0-1 .45-1 1z" }
      })]
    );
  }
};